import { RouteObject } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import ProtectedRoute from "./ProtectedRoute";
import { dashboardRoutes } from "../features/dashboard";
import { kycRoutes } from "../features/kyc";
import { usersRoutes } from "../features/users";
import { settingsRoutes } from "../features/settings";

export const routeConfig: RouteObject[] = [
  {
    element: <ProtectedRoute />,
    children: [
      {
        path: "/",
        element: <MainLayout />,
        children: [...dashboardRoutes, ...kycRoutes, ...usersRoutes, ...settingsRoutes],
      },
    ],
  },
];
